import {
  GlobeAltIcon,
  LightningBoltIcon,
  ScaleIcon,
} from "@heroicons/react/outline";

interface Feature {
  name: string;
  description: string;
  Icon: (props: React.ComponentProps<"svg">) => JSX.Element;
  img: string;
  comingSoon?: true;
}

const features: Feature[] = [
  {
    name: "Span Extraction",
    description: "Rapidly annotate for NER or token classification.",
    Icon: GlobeAltIcon,
    img: "/assets/marketing/icons/paragraph-normal.png",
  },
  {
    name: "Classification",
    description: "Rule-based document classification made easy.",
    Icon: ScaleIcon,
    img: "/assets/marketing/icons/tags.png",
  },
  {
    name: "Data Explorer",
    description:
      "Easily explore large datasets or zoom into specific documents.",
    Icon: LightningBoltIcon,
    img: "/assets/marketing/icons/binocular.png",
  },
  {
    name: "Instant Feedback",
    description:
      "Immediately see the impact of your ideas across your dataset.",
    Icon: LightningBoltIcon,
    img: "/assets/marketing/icons/pulse.png",
  },
  {
    name: "No-code Rule Builders",
    description: "Apply powerful labeling functions with intuitive UI.",
    Icon: LightningBoltIcon,
    img: "/assets/marketing/icons/office-file-glue.png",
    comingSoon: true,
  },
  {
    name: "Export",
    description: "Export your functions and labelled data in popular formats.",
    Icon: LightningBoltIcon,
    img: "/assets/marketing/icons/upload-thick-box.png",
  },
];

export const FeaturesSection = () => {
  return (
    <div className="container-lg grid-12 bg-white py-48">
      <dl className="col-span-full grid gap-32 sm:col-span-10 sm:col-start-2 sm:-mr-40 sm:grid-cols-2 sm:gap-40 lg:grid-cols-3 lg:gap-80">
        {features.map((feature) => (
          <div
            key={feature.name}
            className="flex items-start gap-24 md:flex-col"
          >
            <img
              src={feature.img}
              alt={feature.name}
              className="mt-4 h-28 w-28 md:h-40 md:w-40"
            />
            <div>
              <dt className="flex flex-wrap items-center gap-x-8 gap-y-4">
                <p className="text-16-24 font-bold text-gray-900">
                  {feature.name}
                </p>
                {feature.comingSoon && (
                  <div className="h-min rounded bg-yellow-200 px-4 py-2 text-11-14">
                    <span className="whitespace-nowrap text-11-14 font-bold text-yellow-800">
                      Coming soon
                    </span>
                  </div>
                )}
              </dt>
              <dd className="mt-8 mr-20 text-16-24 text-gray-700">
                {feature.description}
              </dd>
            </div>
          </div>
        ))}
      </dl>
    </div>
  );
};
